import type { AppRoute } from "./types";
import { PATHS } from "./paths";
import { WorkOrderPage } from "../../pages/work-order";
import { WorkOrderCreatePage } from "../../pages/work-order-create";
import LoginPage from "../../pages/login/LoginPage";
import { Calendar } from "../../pages/calendar";
import { ZeitmanagementPage } from "../../pages/zeitmanagement";
import { TimeManagementCreatePage } from "../../pages/zeitmanagement-create";
import { TimeManagementEditPage } from "../../pages/zeitmanagement-edit";
import { AufgabenPage } from "../../pages/aufgaben";
import { AufgabenCreatePage } from "../../pages/aufgaben-create";
import { AufgabenEditPage } from "../../pages/aufgaben-edit";
import { ReschedulePage } from "../../pages/reschedule";
import { DispositionPage } from "../../pages/disposition";
import { TaskPlanPage } from "../../pages/task-plan";
import { WorkOrderDetailPage } from "../../pages/work-order-detail";
import { UserManagementPage } from "../../pages/user-management";
import { UserCreatePage } from "../../pages/user-create";
import { UserEditPage } from "../../pages/user-edit";
import { WorkerCalendarPage } from "../../pages/worker-calendar";
import { WorkerPrivatzeitPage } from "../../pages/worker-privatzeit";
import { WorkerAppointmentPage } from "../../pages/worker-appointment";
import { WorkerZeitmanagementEditPage } from "../../pages/worker-zeitmanagement-edit/WorkerZeitmanagementEditPage";
import { WorkerTaskPage } from "../../pages/worker-task/WorkerTaskPage";
import { ControllingPage } from "src/pages/controlling";
import { ForgotPasswordPage } from "../../pages/forgot-password";
import { ResetPasswordPage } from "../../pages/reset-password";
import { SettingsPage, MailSettingsPage } from "../../pages/settings";
import { ArbeitszeitReportPage } from "../../pages/arbeitszeit-report";
import { Navigate } from "react-router-dom";

export const routeConfig: AppRoute[] = [
  {
    path: PATHS.login,
    element: <LoginPage />,
    isPublic: true,
  },
  {
    path: PATHS.workOrderPage,
    element: <WorkOrderPage />,
    onlyAuth: true,
    roles: ['MANAGER', 'DIRECTOR', 'SUPERUSER'],
  },
  {
    path: PATHS.workOrderCreate,
    element: <WorkOrderCreatePage />,
    onlyAuth: true,
  },
  {
    path: PATHS.calendar,
    element: <Calendar />,
    onlyAuth: true,
  },
  {
    path: PATHS.zeitmanagement,
    element: <ZeitmanagementPage />,
    onlyAuth: true,
  },
  {
    path: PATHS.zeitmanagementCreate,
    element: <TimeManagementCreatePage />,
    onlyAuth: true,
  },
  {
    path: PATHS.zeitmanagementEdit,
    element: <TimeManagementEditPage />,
    onlyAuth: true,
  },
  {
    path: PATHS.aufgaben,
    element: <AufgabenPage />,
    onlyAuth: true,
  },
  {
    path: PATHS.aufgabenCreate,
    element: <AufgabenCreatePage />,
    onlyAuth: true,
  },
  {
    path: PATHS.aufgabenPlan,
    element: <TaskPlanPage />,
    onlyAuth: true,
  },
  {
    path: PATHS.aufgabenEdit,
    element: <AufgabenEditPage />,
    onlyAuth: true,
  },
  {
    path: PATHS.reschedule,
    element: <ReschedulePage />,
    onlyAuth: true,
  },
  {
    path: PATHS.disposition,
    element: <DispositionPage />,
    onlyAuth: true,
  },
  {
    path: PATHS.workOrderDetail,
    element: <WorkOrderDetailPage />,
    onlyAuth: true,
  },
  {
    path: PATHS.users,
    element: <UserManagementPage />,
    onlyAuth: true,
    roles: [ 'DIRECTOR', 'SUPERUSER'],
  },
  {
    path: PATHS.userCreate,
    element: <UserCreatePage />,
    onlyAuth: true,
    roles: [ 'DIRECTOR', 'SUPERUSER'],
  },
  {
    path: PATHS.userEdit,
    element: <UserEditPage />,
    onlyAuth: true,
    roles: [ 'DIRECTOR', 'SUPERUSER'],
  },
  {
    path: PATHS.workerCalendar,
    element: <WorkerCalendarPage />,
    onlyAuth: true,
    roles: ['WORKER', 'SUPERUSER'],
  },
  {
    path: PATHS.workerPrivatzeit,
    element: <WorkerPrivatzeitPage />,
    onlyAuth: true,
    roles: ['WORKER', 'SUPERUSER'],
  },
  {
    path: PATHS.workerAppointment,
    element: <WorkerAppointmentPage />,
    onlyAuth: true,
    roles: ['WORKER', 'SUPERUSER'],
  },
  {
    path: PATHS.workerZeitmanagementEdit,
    element: <WorkerZeitmanagementEditPage />,
    onlyAuth: true,
    roles: ['WORKER', 'SUPERUSER'],
  },
  {
    path: PATHS.workerTask,
    element: <WorkerTaskPage />,
    onlyAuth: true,
    roles: ['WORKER', 'SUPERUSER'],
  },

  {
    path: PATHS.controlling,
    element: <ControllingPage />,
    onlyAuth: true,
    roles: ['MANAGER', 'SUPERUSER'],
  },
  {
    path: PATHS.forgotPassword,
    element: <ForgotPasswordPage />,
    isPublic: true,
  },
  {
    path: PATHS.resetPassword,
    element: <ResetPasswordPage />,
    isPublic: true,
  },
  {
    path: PATHS.arbeitszeitReport,
    element: <ArbeitszeitReportPage />,
    onlyAuth: true,
    roles: ['DIRECTOR', 'SUPERUSER'],
  },
  {
    path: PATHS.settings,
    element: <SettingsPage />,
    onlyAuth: true,
    roles: ['SUPERUSER'],
    children: [
      { path: '', element: <Navigate to={PATHS.settingsMail} replace /> },
      { path: 'mail', element: <MailSettingsPage /> },
    ],
  },
];
